<template>
  <button class="btn btn-primary" @click="handleClick">
    <i v-if="!isExchange" class="fa fa-plus-circle"></i>
    <img v-else class="trade-img" src="../static/trade-icon.svg" alt="Trade" />
    <span class="d-none d-md-inline hidden-xs-down ml-2">
      {{ isExchange ? tradeText : text }}
    </span>
  </button>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import options from "@/options";

export default {
  name: "AddAssetButton",
  props: {
    text: {
      type: String,
      required: true,
    },
    big: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isExchange() {
      return false;
      // return this.assetsTableExchId > 0;
    },
    exchange() {
      return options.exchIdToObj(this.assetsTableExchId) || {};
    },
    apikey() {
      return this.apikeys.find((v) => v.exchId === this.assetsTableExchId);
    },
    tradeText() {
      return !this.big || this.apikey.exists
        ? (this.$t("exchange.trade") + (this.big ? ' '+this.exchange.name : ''))
        : this.$t("exchange.add_exchange_api_key", { exchange: this.exchange.name });
    },
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
      apikeys: "exchange/apikeys",
      assetsTableExchId: "settings/assetsTableExchId",
    }),
  },
  watch: {
    assetsTableExchId() {
      if (this.isLoggedIn && this.isExchange && !this.apikey.exists) {
        this.fetchApikeys(this.assetsTableExchId);
      }
    },
  },
  methods: {
    handleClick() {
      if (this.isExchange) {
        if (!this.isLoggedIn) {
          this.toggleDialog("signIn", true);
          return;
        }
        if (!this.apikey.exists) {
          this.$router.push("/exchange/apikeys");
          return;
        }
        this.$router.push(`/exchange/trade/${this.assetsTableExchId}/add`);
        return;
      }
      this.$router.push("/add");
    },
    ...mapActions({
      fetchApikeys: "exchange/fetchApikeys",
      toggleDialog: "ui/toggleDialog",
    }),
  },
};
</script>

<style scoped>
.trade-img {
  filter: brightness(10);
  width: 19px;
}
</style>